import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Search } from "lucide-react";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  const category = params.get("category") || "";
  const sort = params.get("sort") || "newest";
  const search = params.get("q") || "";
  const size = params.get("size") || "";
  const color = params.get("color") || "";
  const newDrop = params.get("new") === "1";

  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);

  useEffect(() => {
    setLoading(true);
    const q = {};
    if (category) q.category = category;
    if (sort) q.sort = sort;
    if (search) q.search = search;
    if (size) q.size = size;
    if (color) q.color = color;
    if (newDrop) q.new_drop = true;
    api.get("/products", { params: q }).then((r) => { setProducts(r.data); setLoading(false); });
  }, [category, sort, search, size, color, newDrop]);

  const setP = (k, v) => {
    const n = new URLSearchParams(params);
    if (!v) n.delete(k); else n.set(k, v);
    setParams(n);
  };

  return (
    <div className="max-w-[1600px] mx-auto px-4 sm:px-8 py-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
        <h1 className="display text-5xl md:text-7xl">{newDrop ? "LATEST DROPS" : "SHOP"}</h1>
        <div className="flex items-center gap-2 border border-[color:var(--border)] px-3 py-2 max-w-md w-full">
          <Search size={16} strokeWidth={1.25} />
          <input data-testid="shop-search" placeholder="Cari nama atau kode artikel (TS-001)" defaultValue={search}
            onKeyDown={(e) => e.key === "Enter" && setP("q", e.currentTarget.value)}
            className="bg-transparent outline-none w-full text-sm" />
        </div>
      </div>

      <div className="grid md:grid-cols-[220px,1fr] gap-8">
        <aside className="space-y-6 text-sm">
          <div>
            <div className="text-[10px] tracking-widest text-neutral-500 mb-2">KATEGORI</div>
            <button data-testid="filter-cat-all" onClick={() => setP("category", "")} className={`block py-1 ${!category ? "text-white" : "text-neutral-400"}`}>SEMUA</button>
            {cats.map((c) => (
              <button key={c.id} data-testid={`filter-cat-${c.slug}`} onClick={() => setP("category", c.slug)} className={`block py-1 ${category === c.slug ? "text-white" : "text-neutral-400"}`}>{c.name.toUpperCase()}</button>
            ))}
          </div>
          <div>
            <div className="text-[10px] tracking-widest text-neutral-500 mb-2">UKURAN</div>
            <div className="flex flex-wrap gap-2">
              {["S","M","L","XL","XXL"].map((s) => (
                <button key={s} data-testid={`filter-size-${s}`} onClick={() => setP("size", size === s ? "" : s)}
                  className={`hairline w-10 h-10 text-xs ${size === s ? "bg-white text-black" : ""}`}>{s}</button>
              ))}
            </div>
          </div>
          <div>
            <div className="text-[10px] tracking-widest text-neutral-500 mb-2">URUTKAN</div>
            <select data-testid="sort-select" value={sort} onChange={(e) => setP("sort", e.target.value)} className="hairline w-full p-2 text-sm bg-black">
              <option value="newest">Terbaru</option>
              <option value="price_asc">Harga: Rendah ke Tinggi</option>
              <option value="price_desc">Harga: Tinggi ke Rendah</option>
            </select>
          </div>
        </aside>

        <div>
          {loading ? (
            <div className="text-neutral-500 text-sm">Memuat...</div>
          ) : products.length === 0 ? (
            <div data-testid="shop-empty" className="text-neutral-500 text-sm py-16">Tidak ada produk ditemukan.</div>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
              {products.map((p) => <ProductCard key={p.id} product={p} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
